/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";
import * as MetadataContentWarnings from "./metadata/contentWarnings.defs.js";
import * as MetadataContentRights from "./metadata/contentRights.defs.js";
import * as MetadataDistributionPolicy from "./metadata/distributionPolicy.defs.js";

const $nsid = "place.stream.segment";

export { $nsid };

/** Media file representing a segment of a livestream */
type Main = { $type: "place.stream.segment";

  /**
   * Unique identifier for the segment
   */
  "id":string;

  /**
   * The DID of the signing key used for this segment
   */
  "signingKey":string;

  /**
   * When this segment started
   */
  "startTime":l.DatetimeString;

  /**
   * The duration of the segment in nanoseconds
   */
  "duration"?:number;"creator":l.DidString;"video"?:(Video)[];"audio"?:(Audio)[];

  /**
   * The size of the segment in bytes
   */
  "size"?:number;"contentWarnings"?:MetadataContentWarnings.Main;"contentRights"?:MetadataContentRights.Main;"distributionPolicy"?:MetadataDistributionPolicy.Main };

export type { Main };

/** Media file representing a segment of a livestream */
const main = /*#__PURE__*/ l.record<"tid", Main>("tid", $nsid, /*#__PURE__*/ l.object({"id":/*#__PURE__*/ l.string(),"signingKey":/*#__PURE__*/ l.string(),"startTime":/*#__PURE__*/ l.string({"format":"datetime"}),"duration":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),"creator":/*#__PURE__*/ l.string({"format":"did"}),"video":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<Video>((() => video) as any), )),"audio":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<Audio>((() => audio) as any), )),"size":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),"contentWarnings":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<MetadataContentWarnings.Main>((() => MetadataContentWarnings.main) as any)),"contentRights":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<MetadataContentRights.Main>((() => MetadataContentRights.main) as any)),"distributionPolicy":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<MetadataDistributionPolicy.Main>((() => MetadataDistributionPolicy.main) as any))}));

export { main };

export const $type = $nsid;
export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main);
export const $build = /*#__PURE__*/ main.build.bind(main);
export const $assert = /*#__PURE__*/ main.assert.bind(main);
export const $check = /*#__PURE__*/ main.check.bind(main);
export const $cast = /*#__PURE__*/ main.cast.bind(main);
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main);
export const $matches = /*#__PURE__*/ main.matches.bind(main);
export const $parse = /*#__PURE__*/ main.parse.bind(main);
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main);
export const $validate = /*#__PURE__*/ main.validate.bind(main);
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main);

type Audio = { $type?: "place.stream.segment#audio";"codec":"opus" | "aac";"rate":number;"channels":number };

export type { Audio };

const audio = /*#__PURE__*/ l.typedObject<Audio>($nsid, "audio", /*#__PURE__*/ l.object({"codec":/*#__PURE__*/ l.enum(["opus","aac"]),"rate":/*#__PURE__*/ l.integer(),"channels":/*#__PURE__*/ l.integer()}));

export { audio };

type Video = { $type?: "place.stream.segment#video";"codec":"h264";"width":number;"height":number;"framerate"?:Framerate;"bframes"?:boolean };

export type { Video };

const video = /*#__PURE__*/ l.typedObject<Video>($nsid, "video", /*#__PURE__*/ l.object({"codec":/*#__PURE__*/ l.literal("h264"),"width":/*#__PURE__*/ l.integer(),"height":/*#__PURE__*/ l.integer(),"framerate":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<Framerate>((() => framerate) as any)),"bframes":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean())}));

export { video };

type Framerate = { $type?: "place.stream.segment#framerate";"num":number;"den":number };

export type { Framerate };

const framerate = /*#__PURE__*/ l.typedObject<Framerate>($nsid, "framerate", /*#__PURE__*/ l.object({"num":/*#__PURE__*/ l.integer(),"den":/*#__PURE__*/ l.integer()}));

export { framerate };

type SegmentView = { $type?: "place.stream.segment#segmentView";"cid":l.CidString;"record":l.LexMap };

export type { SegmentView };

const segmentView = /*#__PURE__*/ l.typedObject<SegmentView>($nsid, "segmentView", /*#__PURE__*/ l.object({"cid":/*#__PURE__*/ l.string({"format":"cid"}),"record":/*#__PURE__*/ l.lexMap()}));

export { segmentView };
